import { AUTH_CONNECTION, type AUTH_CONNECTION_TYPE } from "@web3auth/auth";

/** Auth0 Passwordless Email connection name (must match tenant Passwordless \> Email). */
export const AUTH0_PASSWORDLESS_EMAIL_CONNECTION = import.meta.env.VITE_AUTH0_PASSWORDLESS_EMAIL_CONNECTION || "email";

/** Auth0 connection name per dashboard login method. */
const AUTH0_CONNECTION_MAP: Record<string, string> = {
  [AUTH_CONNECTION.GOOGLE]: "google-oauth2",
  [AUTH_CONNECTION.GITHUB]: "github",
  [AUTH_CONNECTION.APPLE]: "apple",
  [AUTH_CONNECTION.EMAIL_PASSWORDLESS]: AUTH0_PASSWORDLESS_EMAIL_CONNECTION,
};

/** Dashboard DB verifier per login method (new Auth0 tenant). */
const VERIFIER_MAP: Record<string, string> = {
  [AUTH_CONNECTION.GOOGLE]: "auth0-google",
  [AUTH_CONNECTION.GITHUB]: "auth0-github",
  [AUTH_CONNECTION.APPLE]: "auth0-apple",
  [AUTH_CONNECTION.EMAIL_PASSWORDLESS]: "auth0-email-passwordless",
};

export function getAuth0Connection(authConnection: AUTH_CONNECTION_TYPE | string): string {
  const connection = AUTH0_CONNECTION_MAP[authConnection];
  if (!connection) {
    throw new Error(`Unsupported auth connection: ${authConnection}`);
  }
  return connection;
}

export function getVerifierForConnection(authConnection: AUTH_CONNECTION_TYPE | string): string {
  const verifier = VERIFIER_MAP[authConnection];
  if (!verifier) {
    throw new Error(`Unsupported auth connection: ${authConnection}`);
  }
  return verifier;
}

export function isSupportedAuthConnection(authConnection: string): authConnection is AUTH_CONNECTION_TYPE {
  return authConnection in AUTH0_CONNECTION_MAP;
}
